angular.module('unica_media_directory.media_directory_controllers', [])

.controller('MediaDirectoryBasicController',
	function(
		$rootScope, $scope
	) {

	$scope.forms = {};

	$scope.showDelete = true;
});